export default __webpack_public_path__ + "_/node_modules/intl-tel-input/build/img/flags.png";